import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooterComponent {

  versionnumber: string;

  constructor(
    private router: Router,
    private apiService: ApiService
  ) {
  }

  ngOnInit(){ 

    this.apiService.postAs<any>('data/doquery/SYS_GetCurrentVersion',{}).then(response => {
        this.versionnumber = response.Item.VersionNumber;
    });
  }
}





// WEBPACK FOOTER //
// ./src/app/components/app-footer/app-footer.component.ts